import { useEffect, useRef, useState } from 'react'
import { LightboxImage } from './Lightbox'

const DictionarySection = () => {
  const posterRef = useRef<HTMLDivElement>(null)
  const [inView, setInView] = useState(false)

  useEffect(() => {
    const el = posterRef.current
    if (!el) return
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setInView(true); observer.disconnect() } },
      { threshold: 0.2 }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return (
    <section className="relative w-full bg-black overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-black via-[#0a0f1a] to-black"></div>
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-4 lg:gap-6 max-w-5xl mx-auto">

          {/* Definition — left */}
          <div className="lg:w-1/2 flex flex-col justify-center order-2 lg:order-1">
            <p className="text-white font-montserrat font-black text-2xl md:text-3xl italic tracking-wide mb-1">
              spoke
            </p>
            <p className="text-white text-sm md:text-base font-poppins font-light tracking-widest mb-3">
              [sp&#x14D;k]
            </p>
            <p className="text-white text-base md:text-lg font-poppins font-light italic leading-relaxed">
              <span className="text-white not-italic font-normal">n.</span> any of the small radiating bars inserted<br />
              in the hub of a wheel to support the rim
            </p>
            <p className="text-white text-base md:text-lg font-poppins font-light italic leading-relaxed mt-3">
              <span className="text-white not-italic font-normal">v.</span> that someone communicated orally, expressed thoughts, or delivered a speech
            </p>
          </div>

          {/* Poster — right, slides in from right */}
          <div
            ref={posterRef}
            className="lg:w-1/2 order-1 lg:order-2 flex justify-center"
          >
            <div
              className={`w-[90%] md:w-[45%] lg:w-[65%] rounded-lg overflow-hidden
                transition-all duration-700 ease-out
                ${inView ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-20'}`}
            >
              <LightboxImage
                src="/spoke-static/images/spoke-poster-final.jpg"
                alt="SPOKE film official poster"
                className="w-full h-full object-cover rounded-lg"
              />
            </div>
          </div>

        </div>


      </div>
    </section>
  )
}

export default DictionarySection
